import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import GeneralLoading from '@/components/GeneralLoading';

import { regionsHeaders, regionsRows } from './dependencies/helpers';
import Table from './dependencies/Table';
import useRates from './useRates';

const RatesSection = () => {
  const hook = useRates();
  const theme = useTheme();

  return (
    <>
      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          padding: `${theme.spacing(4)} 0`,
        }}
      >
        {hook.rates.loading ? (
          <Box margin="1rem auto">
            <GeneralLoading size={50} text="Cargando" fontVariant="h6" />
          </Box>
        ) : (
          <Box margin="0 auto" width="100%">
            <Box>
              {hook.country === 'MEX' && (
                <Typography
                  variant="body2"
                  color="secondary"
                  textAlign="end"
                  margin="0 1rem 1rem 0"
                  fontWeight={theme.typography.fontWeightMedium}
                >
                  Los precios indicados no incluyen IVA
                </Typography>
              )}
              {hook.rates.data &&
                hook.table?.map(({ title, headers, rows }, index) => (
                  <Table key={index} title={title} headers={headers} rows={rows} />
                ))}
            </Box>
          </Box>
        )}
      </Paper>
      {hook.country === 'CHL' && (
        <Paper
          elevation={3}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            padding: `${theme.spacing(2)} 0 0`,
            marginTop: '2rem',
          }}
        >
          <Box mt="2rem" width="80%">
            <Typography variant="h5" color="secondary" mb="1rem">
              Regiones por Zona
            </Typography>
            <Divider />
            <Box margin="1rem auto" width="100%" sx={{ borderRadius: '0 0 1rem 1rem' }}>
              <Table untitledRadius headers={regionsHeaders} rows={regionsRows} lastChl />
            </Box>
          </Box>
        </Paper>
      )}
    </>
  );
};

export default RatesSection;
